
const find = require('lodash/collection/find');
const { formatText } = require('core/i18n').i18n;

function getDoc (labels, docType, docNumber){
    const docNotDefined = find(labels, (doc) => doc.type === "nd");
    const labelCheck = find(labels, (doc) => doc.type === docType.toLowerCase());
    const label = (labelCheck) ? formatText(labelCheck.value) : (docNotDefined) && formatText(docNotDefined.value);
    const number = ( docNumber.length > 0 ) ? docNumber : "-";
    return {label: label, number: number};
}

module.exports = {
    getDoc
}
